import { usePage } from "@inertiajs/react";
import type { PageProps } from "@/types/global";

export const useTypedPageProps = <T extends Record<string, unknown> = {}>() => {
    return usePage<PageProps<T>>().props;
};
